function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import moment from 'moment';
import { isEmpty } from 'lodash';
export var serializeMilitary = function serializeMilitary(military) {
  if (!military) return undefined;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, military), military.deployment_ends_at ? {
    deployment_ends_at: moment.unix(military.deployment_ends_at).utc().format('YYYY-MM-DD')
  } : {}), military.deployment_starts_at ? {
    deployment_starts_at: moment.unix(military.deployment_starts_at).utc().format('YYYY-MM-DD')
  } : {}), military.entry_date ? {
    entry_date: moment.unix(military.entry_date).utc().format('YYYY-MM-DD')
  } : {}), military.exit_date ? {
    exit_date: moment.unix(military.exit_date).utc().format('YYYY-MM-DD')
  } : {});
};
export var deserializeMilitary = function deserializeMilitary(military) {
  if (!military) return undefined;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, military), military.deployment_ends_at ? {
    deployment_ends_at: moment(military.deployment_ends_at).unix()
  } : {}), military.deployment_starts_at ? {
    deployment_starts_at: moment(military.deployment_starts_at).unix()
  } : {}), military.entry_date ? {
    entry_date: moment(military.entry_date).unix()
  } : {}), military.exit_date ? {
    exit_date: moment(military.exit_date).unix()
  } : {});
};
export var serializePhoneNumbers = function serializePhoneNumbers(phoneNumbers) {
  if (!phoneNumbers || !phoneNumbers.length) {
    return [];
  }
  return phoneNumbers.map(function (phone) {
    var newPhone = _objectSpread({}, phone);
    var phone_number = newPhone.phone_number;
    if (phone_number.length > 10) {
      var new_phone_number = phone_number.substr(0, 10);
      var extension = phone_number.substring(10, phone_number.length);
      newPhone.phone_number = new_phone_number;
      newPhone.extension = extension;
    }
    delete newPhone.id;
    return newPhone;
  });
};
export var deserializePhoneNumbers = function deserializePhoneNumbers(phoneNumbers) {
  if (!phoneNumbers) {
    return [];
  }
  return phoneNumbers.filter(function (phone) {
    return !isEmpty(phone);
  }).map(function (phone, index) {
    return _objectSpread(_objectSpread({}, phone), {}, {
      phone_number: phone.extension ? "".concat(phone.phone_number).concat(phone.extension) : phone.phone_number,
      extension: undefined,
      id: index
    });
  });
};
export var serializeDateOfBirth = function serializeDateOfBirth(dateOfBirth) {
  if (!dateOfBirth) return undefined;
  return moment.unix(dateOfBirth).utc().format('YYYY-MM-DD');
};
export var deserializeDateOfBirth = function deserializeDateOfBirth(dateOfBirth) {
  if (!dateOfBirth) return undefined;
  return moment(dateOfBirth).unix();
};
//# sourceMappingURL=serializationHelpers.js.map